import { makeAutoObservable } from "mobx"

export default class ProjectAsset {
  constructor(projectAsset = {}) {
    this.id = projectAsset.id
    this.campaign_id = projectAsset.campaign_id
    this.name = projectAsset.name || ''
    this.theme_color = projectAsset.theme_color || ''
    this.start = projectAsset.start
    this.end = projectAsset.end
    this.notes = projectAsset.notes ?? ''
    this.phase = projectAsset.phase ?? null

    makeAutoObservable(this)
  }
}
